__turbopack_context__.v({
  "stack-module-0": "Stats-module-scss-module__v9hC0W__stack-module-0",
  "stack-module-1": "Stats-module-scss-module__v9hC0W__stack-module-1",
  "stack-module-10": "Stats-module-scss-module__v9hC0W__stack-module-10",
  "stack-module-11": "Stats-module-scss-module__v9hC0W__stack-module-11",
  "stack-module-12": "Stats-module-scss-module__v9hC0W__stack-module-12",
  "stack-module-13": "Stats-module-scss-module__v9hC0W__stack-module-13",
  "stack-module-14": "Stats-module-scss-module__v9hC0W__stack-module-14",
  "stack-module-15": "Stats-module-scss-module__v9hC0W__stack-module-15",
  "stack-module-16": "Stats-module-scss-module__v9hC0W__stack-module-16",
  "stack-module-17": "Stats-module-scss-module__v9hC0W__stack-module-17",
  "stack-module-18": "Stats-module-scss-module__v9hC0W__stack-module-18",
  "stack-module-19": "Stats-module-scss-module__v9hC0W__stack-module-19",
  "stack-module-2": "Stats-module-scss-module__v9hC0W__stack-module-2",
  "stack-module-20": "Stats-module-scss-module__v9hC0W__stack-module-20",
  "stack-module-3": "Stats-module-scss-module__v9hC0W__stack-module-3",
  "stack-module-4": "Stats-module-scss-module__v9hC0W__stack-module-4",
  "stack-module-5": "Stats-module-scss-module__v9hC0W__stack-module-5",
  "stack-module-6": "Stats-module-scss-module__v9hC0W__stack-module-6",
  "stack-module-7": "Stats-module-scss-module__v9hC0W__stack-module-7",
  "stack-module-8": "Stats-module-scss-module__v9hC0W__stack-module-8",
  "stack-module-9": "Stats-module-scss-module__v9hC0W__stack-module-9",
  "statColumn": "Stats-module-scss-module__v9hC0W__statColumn",
  "statContent": "Stats-module-scss-module__v9hC0W__statContent",
  "statLabel": "Stats-module-scss-module__v9hC0W__statLabel",
  "statLink": "Stats-module-scss-module__v9hC0W__statLink",
  "statList": "Stats-module-scss-module__v9hC0W__statList",
  "statValue": "Stats-module-scss-module__v9hC0W__statValue",
  "stats": "Stats-module-scss-module__v9hC0W__stats",
  "z-base": "Stats-module-scss-module__v9hC0W__z-base",
  "z-content": "Stats-module-scss-module__v9hC0W__z-content",
  "z-footer": "Stats-module-scss-module__v9hC0W__z-footer",
  "z-header": "Stats-module-scss-module__v9hC0W__z-header",
  "z-hero": "Stats-module-scss-module__v9hC0W__z-hero",
  "z-logo": "Stats-module-scss-module__v9hC0W__z-logo",
  "z-logo-effect": "Stats-module-scss-module__v9hC0W__z-logo-effect",
  "z-navigation": "Stats-module-scss-module__v9hC0W__z-navigation",
  "z-sub": "Stats-module-scss-module__v9hC0W__z-sub",
});
